import React, { Component } from "react";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";
import { cx } from "emotion";
import { _t } from "js/utils/TranslationService";

import Condiciones from "./Condiciones";
import Sucursales from "./Sucursales";
import Descripcion from "./Descripcion";
import Button from "@material-ui/core/Button";

class Beneficio extends Component {
  backToCatalogo = () => {
    const { history } = this.props;
    history.push({ pathname: "/catalogo-codigos", state: { filter: true } });
  };

  render() {
    const condiciones = this.props.beneficio.condiciones;
    const sucursales = this.props.beneficio.sucursales;
    const beneficio = this.props.beneficio;

    return (
      <div>
        <Grid
          container
          className={cx(
            this.props.classes.producto,
            this.props.classes.detailWrapper
          )}
        >
          <Descripcion
            eleccionBeneficio={this.props.eleccionBeneficio}
            classes={this.props.classes}
          />
          {beneficio.tieneSucursales &&
            sucursales.find(s => s.estado === "ACTIVO") && (
              <Sucursales
                beneficio={this.props.beneficio}
                sucursales={sucursales.filter(s => s.estado === "ACTIVO")}
                classes={this.props.classes}
              />
            )}
          {condiciones && <Condiciones condiciones={condiciones} />}
          <Grid item xs={12}>
            <Button
              style={{ float: "right" }}
              onClick={this.backToCatalogo}
              variant="contained"
              color="primary"
            >
              {_t("Volver al catálogo")}
            </Button>
          </Grid>
        </Grid>
      </div>
    );
  }
}

Beneficio.defaultProps = {
  text: "Beneficio"
};

Beneficio.propTypes = {
  text: PropTypes.string.isRequired
};

export default Beneficio;
